import { Component, OnInit, OnDestroy } from '@angular/core';
import { DatePipe } from '@angular/common';
import { SiteDashboardService } from '../../site-dashboard.service';
import { UserService } from '../../../../auth/user.service';
import { BattviewsDashboardService } from '../battviews-dashboard/battviews-dashboard.service';
import { CommonUtil } from '../../../../shared/services/utility/common.service';
import { SideMenuService } from '../../../../shared/side-menu/side-menu.service';
import * as moment from 'moment';

@Component({
	selector: 'app-fleet-status',
	templateUrl: './fleet-status.component.html',
	styleUrls: ['./fleet-status.component.css'],
})
export class FleetStatusComponent implements OnInit, OnDestroy {
	columns: any;
	user;
	customerId;
	siteId;
	data;
	siteBattviewsData;
	siteTags;
	siteBattviewsTags;
	customerName: string = '';
	siteName: string = '';
	currentSiteSub: any;
	activeDataSub: any;
	battviewDashBoardSub: any;
	battviewEventsSub: any;
	tableData: Array<Object> = [];
	reorderableColumns: boolean = true;

	tableStyle = {
		height: '80vh',
		"max-height": "85vh"
	}

	constructor(
		private siteDashboardService: SiteDashboardService,
		private battviewsDashboardService: BattviewsDashboardService,
		private userService: UserService,
		private sideMenu: SideMenuService,
		private commonUtil: CommonUtil,
	) {
		this.siteDashboardService.setActiveSubTab('fleet-status');
	}

	ngOnInit() {
		this.setColumns();
		this.user = this.userService.getCurrentUser();


		let toDate = new Date();
		let fromDate = new Date();
		fromDate.setMonth(toDate.getMonth() -1);
		let fromDateApi = moment(fromDate).utc().startOf('day').format("X");
		let toDateApi = moment(toDate).utc().startOf('day').format("X")
		let fromDateMoment = new Date(moment(fromDate).startOf('day').unix() * 1000);
		let toDateMoment = new Date(moment(toDate).startOf('day').unix() * 1000);
		let fromDateUnix = new Date(-fromDateMoment.getTimezoneOffset() * 60000 + fromDateMoment.getTime()).getTime() / 1000;
		let endDateUnix = new Date(-toDateMoment.getTimezoneOffset() * 60000 + toDateMoment.getTime()).getTime() / 1000;

		this.currentSiteSub = this.sideMenu.currentSite.subscribe(siteInfo => {
			this.customerId = siteInfo.customerid;
			this.siteId = siteInfo.id;
			this.customerName = siteInfo.customer_name;
			this.siteName = siteInfo.name;
			let newTableData = [];

			if (this.customerId && this.siteId) {
				this.activeDataSub = this.siteDashboardService.activeDashboardData.subscribe(data => this.data = Object.assign({}, data));
				this.siteDashboardService.getDashboardData(this.customerId, this.siteId);
				this.battviewDashBoardSub = this.battviewsDashboardService.getBattviews({ customerid: this.customerId, siteid: this.siteId, getTags: true }).subscribe((response: any) => {

					this.siteBattviewsData = this.commonUtil.arrayToAssociativeArray(response.list, 'id');
					let battviewData = {};
					let lastConnectionTimeData = {};

					// Get last connection time
					for (let battviewKey in this.siteBattviewsData) {
						const batteryid = this.siteBattviewsData[battviewKey].batteryid;
						battviewData['lastconnecttime'] = this.siteBattviewsData[battviewKey].lastconnecttime || '';
						lastConnectionTimeData[batteryid] = { ...battviewData };
						battviewData = {};
					}


					// Get event data
					this.battviewEventsSub = this.battviewsDashboardService.getAllBattviewEventRecords(this.siteId, { fromDate:fromDateApi, toDate:toDateApi, limit: 18 }).subscribe((res: any) => {
						for (let deviceData of res) {
							let device = deviceData.device;
							let battviewEvents = deviceData.events;
							this.battviewsDashboardService.generateSequentialSummaryData(battviewEvents);
							this.battviewsDashboardService.generateEndTemperature(battviewEvents);
							battviewEvents = battviewEvents.filter((item:any) => {return item.data.start_time >= fromDateUnix && item.data.endTime <= endDateUnix});
							let formatResult = this.battviewsDashboardService.formatData(battviewEvents, device);

							let currentEvent:any = formatResult.formattedSequentials[0] ?? [];
							battviewData['batteryid'] = device.batteryid;
							battviewData['lastconnecttime'] = lastConnectionTimeData[device.batteryid].lastconnecttime ? this.timeFormatter(lastConnectionTimeData[device.batteryid].lastconnecttime) : "";
							battviewData['end_soc'] = currentEvent?.end_soc !== null && currentEvent?.end_soc !== undefined ? currentEvent.end_soc + "%" : "";
							battviewData['has_eq'] = currentEvent?.has_eq != null ? (currentEvent.has_eq ? "True" : "False") : "";
							battviewData['end_temperature_formatted'] = currentEvent?.end_temperature_formatted ? (!isNaN(currentEvent.end_temperature_formatted) ? currentEvent.end_temperature_formatted + " F" : currentEvent.end_temperature_formatted) : "";
							battviewData['event_name_formatted'] = currentEvent?.event_name_formatted ? currentEvent.event_name_formatted : "";

							newTableData.push({ ...battviewData });
							battviewData = {};
						}
						this.tableData = newTableData;
					});
				});
			}
		});
	}

	setColumns() {
		this.columns = [
			{ headerName: "Battery ID", field: "batteryid" },
			{ headerName: "SOC", field: "end_soc" },
			{ headerName: "Status", field: "event_name_formatted", inputType: 'dropdown', filter: [{ label: "Charge", value: 'Charge' }, { label: "In Use", value: 'In Use' }, { label: 'Idle IaC', value: 'Idle IaC' }, { label: 'Idle IaE', value: 'Idle IaE' }, { label: 'Idle', value: 'Idle' }] },
			{ headerName: "Last Connect Time", field: "lastconnecttime"},
			{ headerName: "EQ", field: "has_eq", inputType: 'dropdown', filter: [{ label: 'True', value: 'True' }, { label: 'False', value: 'False' }] },
			{ headerName: "Temperature", field: "end_temperature_formatted" },
		];
	}

	timeFormatter(value) {
		let datePipe: DatePipe = new DatePipe("en-US");
		return datePipe.transform(value, 'MM/dd/yyyy hh:mm:ss a');
	}

	ngOnDestroy() {
		this.currentSiteSub.unsubscribe();
		if (this.activeDataSub)
			this.activeDataSub.unsubscribe();
		this.battviewDashBoardSub.unsubscribe();
		this.battviewEventsSub.unsubscribe();
	}

	handleSort(event:any){
		if(event.field === "end_soc" || event.field === 'end_temperature_formatted'){
			this.tableData = this.tableData.sort((a:any, b:any) => {
				if(a[event.field] === "") return 1;
				if(b[event.field] === "") return -1;
				const result = a[event.field].localeCompare(b[event.field], undefined, {numeric: true, sensitivity: 'base'});
				return event.order > 0 ? result : -result;
			});
		  }else if(event.field === 'lastconnecttime'){
			this.tableData = this.tableData.sort((a:any, b:any) => {
			  const date1 = new Date(a.lastconnecttime).getTime();
			  const date2 = new Date(b.lastconnecttime).getTime();
			  return event.order > 0 ? date1 - date2 : date2 - date1;
			});
		  }
		  else{
			this.tableData = this.tableData.sort((a:any, b:any) => {
				if(a[event.field] === "") return 1;
				if(b[event.field] === "") return -1;
				return event.order > 0 ?  a[event.field].localeCompare(b[event.field]) :  b[event.field].localeCompare(a[event.field])
			});
		  }
	}
}
